import type { OrganisationThemeUpdate } from "@peer-start/platform-contracts";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { administrationQueryKey, bootstrapQueryKey } from "../../prototype/api/queries.js";
import { fetchOrganisationTheme, saveOrganisationTheme } from "./client.js";

export const organisationThemeKey = (organisationId: string) =>
  ["organisation-theme", organisationId] as const;

export function useOrganisationTheme(organisationId: string | null) {
  return useQuery({
    queryKey: organisationThemeKey(organisationId ?? "none"),
    queryFn: () => fetchOrganisationTheme(organisationId!),
    enabled: organisationId !== null,
  });
}

export function useSaveOrganisationTheme(organisationId: string) {
  const queryClient = useQueryClient();
  const queryKey = organisationThemeKey(organisationId);
  return useMutation({
    mutationFn: (update: OrganisationThemeUpdate) => saveOrganisationTheme(organisationId, update),
    onSuccess: async (theme) => {
      queryClient.setQueryData(queryKey, theme);
      await queryClient.invalidateQueries({ queryKey: bootstrapQueryKey });
      await queryClient.invalidateQueries({ queryKey: administrationQueryKey });
    },
  });
}
